__turbopack_context__.v({
  "active": "page-module-scss-module__b93uqW__active",
  "addToCart": "page-module-scss-module__b93uqW__addToCart",
  "details": "page-module-scss-module__b93uqW__details",
  "grid": "page-module-scss-module__b93uqW__grid",
  "imageFrame": "page-module-scss-module__b93uqW__imageFrame",
  "info": "page-module-scss-module__b93uqW__info",
  "introRichText": "page-module-scss-module__b93uqW__introRichText",
  "label": "page-module-scss-module__b93uqW__label",
  "loading": "page-module-scss-module__b93uqW__loading",
  "loadingSpin": "page-module-scss-module__b93uqW__loadingSpin",
  "name": "page-module-scss-module__b93uqW__name",
  "notFound": "page-module-scss-module__b93uqW__notFound",
  "price": "page-module-scss-module__b93uqW__price",
  "product": "page-module-scss-module__b93uqW__product",
  "quantityControls": "page-module-scss-module__b93uqW__quantityControls",
  "quantitySelector": "page-module-scss-module__b93uqW__quantitySelector",
  "related": "page-module-scss-module__b93uqW__related",
  "relatedGrid": "page-module-scss-module__b93uqW__relatedGrid",
  "relatedSection": "page-module-scss-module__b93uqW__relatedSection",
  "relatedTitle": "page-module-scss-module__b93uqW__relatedTitle",
  "sizeBtn": "page-module-scss-module__b93uqW__sizeBtn",
  "sizeSelector": "page-module-scss-module__b93uqW__sizeSelector",
  "sizes": "page-module-scss-module__b93uqW__sizes",
  "specs": "page-module-scss-module__b93uqW__specs",
  "spinner": "page-module-scss-module__b93uqW__spinner",
  "totalPrice": "page-module-scss-module__b93uqW__totalPrice",
});
